import { useState } from "react";
import { MailPlus, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useApi, useResource, errorText } from "@/lib/api";

// Invite a director by email; Clerk sends the link, they set their own password and are approved automatically.
export default function InvitePanel({ onChange }) {
  const api = useApi();
  const { data, reload } = useResource("/invitations");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const invite = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api("post", "/invitations", { email: email.trim() });
      toast.success(`Invite sent to ${email.trim()}`);
      setEmail("");
      reload();
      onChange?.();
    } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };
  const revoke = async (i) => {
    try {
      await api("post", `/invitations/${i.id}/revoke`);
      toast.success(`Invite to ${i.email} cancelled`);
      reload();
    } catch (err) { toast.error(errorText(err)); }
  };

  return (
    <div className="border border-border bg-card p-6" data-testid="invite-panel">
      <h2 className="font-display text-xl font-semibold">Add a director</h2>
      <p className="text-sm text-muted-foreground mt-1">They get an email link, set their own password, and can see the records straight away.</p>
      <form onSubmit={invite} className="mt-4 flex flex-wrap gap-3">
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@thewhiteprojectco.com"
          className="max-w-sm rounded-full" data-testid="invite-email-input" />
        <Button type="submit" disabled={busy || !email.trim()} className="rounded-full" data-testid="invite-send-button">
          <MailPlus className="h-4 w-4 mr-2" /> {busy ? "Sending…" : "Send invite"}
        </Button>
      </form>
      {data?.length > 0 && (
        <div className="mt-5" data-testid="invite-pending-list">
          <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Waiting to accept</div>
          {data.map((i) => (
            <div key={i.id} className="flex items-center gap-3 py-2 border-b border-border/60 last:border-0 text-sm" data-testid={`invite-row-${i.email}`}>
              <span className="font-mono text-xs">{i.email}</span>
              <span className="text-muted-foreground text-xs">sent {new Date(i.created_at).toLocaleDateString("en-AU")}</span>
              <Button variant="ghost" size="sm" className="ml-auto rounded-full" onClick={() => revoke(i)} data-testid={`invite-revoke-${i.email}`}>
                <X className="h-4 w-4 mr-1" /> Cancel invite
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
